module.exports = __webpack_public_path__ + "img/34_front_right.af28b83a.jpg";